// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__HSSgc","mobileLayout":"style_mobileLayout__WWX8Z"};